<template>
  <div v-if="tags.length > 0">
    <el-tag @click="goToTag(tag)" :key="tag.id" v-for="tag in tags">
      {{ tag.name }}
    </el-tag>
  </div>
</template>

<script>
export default {
  props: ["tags"],
  methods: {
    goToTag(tag) {
      this.$router.push({
        path: "/tags/" + tag.id + "/" + tag.slug,
        query: { tagName: tag.name }
      });
    }
  }
};
</script>
